// extracted by css-extract-rspack-plugin
export default {"cookieContentDetails":"cookieContentDetails-Rgb_Vq","cookieBox":"cookieBox-JD723N","divider":"divider-fcPEws","cookieBoxrow":"cookieBoxrow-MsDyBN","cookieTag":"cookieTag-PcWVYK"};